import { Injectable } from '@angular/core';

import { RidangoReduxAction, ShoppingCart, Ticket } from '@ridango/core';

import { Action } from 'redux';


export interface ShoppingCartAction extends Action {

    type: string;

    payload?: any;
}


@Injectable({
    providedIn: 'root'
})
export class ShoppingCartActions {


    static UPDATE_SHOPPING_CART = '[ShoppingCart]: Update/create shopping cart';
    static UPDATE_CORP_SHOPPING_CART = '[ShoppingCart]: Update/create corporate shopping cart';

    static DELETE_SHOPPING_CART = '[ShoppingCart] Delete shopping cart';

    static POST_TICKET_TO_CART_START = '[ShoppingCart]: Post ticket request START';
    static POST_TICKET_TO_CART_SUCCESS = '[ShoppingCart]: Post ticket request SUCCESS';
    static POST_TICKET_TO_CART_ERROR = '[ShoppingCart]: Post ticket request ERROR';
    static POST_TICKET_TO_CART_DONE = '[ShoppingCart]: Post ticket request DONE';

    static ADD_TICKET_TO_CART = '[ShoppingCart]: Add ticket to cart';

    static FETCH_CART_START = '[ShoppingCart] Fetch shopping cart START';
    static FETCH_CART_SUCCESS = '[ShoppingCart] Fetch shopping cart SUCCESS';
    static FETCH_CART_ERROR = '[ShoppingCart] Fetch shopping cart ERROR';
    static FETCH_CART_DONE = '[ShoppingCart] Fetch shopping cart DONE';


    static REMOVE_TICKET_FROM_CART = '[ShoppingCart] Remove ticket from cart';
    static REMOVE_GROUPED_TICKET_FROM_CART = '[ShoppingCart] Remove grouped ticket from cart';

    static UPDATE_CART_TOTAL_PRICE = '[ShoppingCart] Update cart price';

    static GROUP_CORPORATE_TICKETS = '[ShoppingCart] Group corporate tickets';

    static ADD_LOCAL_TICKET_TO_CART = '[ShoppingCart] Add local ticket to cart';
    static ADD_LOCAL_TICKET_UID_TO_CART = '[ShoppingCart] Add local ticket uid to cart';

    static ADD_VOUCHER_TICKET_TO_CART = '[ShoppingCart] Add voucher ticket to cart';

    static DECREMENT_CART_TIMER = '[ShoppingCart] Decrement cart timer';

    static SET_CART_TIMER = '[ShoppingCart] Set timer';
    static SET_CART_STATUS = '[ShoppingCart] Set status';


    static UPDATE_LOCAL_TICKET_PRICE = '[ShoppingCart] Update local ticket price';

    static CLEAR_CART = '[ShoppingCart] Clear cart';

    static SET_CART_TERMS_AGREED = '[ShoppingCart] Set terms agreed';

    static HYDRATE_CART_STATE = '[ShoppingCart] Hydrate cart state';


    updateShoppingCart(payload: ShoppingCart): ShoppingCartAction {
        return {
            type: ShoppingCartActions.UPDATE_SHOPPING_CART,
            payload: payload
        };
    }

    updateCorpShoppingCart(payload: ShoppingCart): ShoppingCartAction {
        return {
            type: ShoppingCartActions.UPDATE_CORP_SHOPPING_CART,
            payload: payload
        };
    }

    updateCartTotalPrice(payload: any): RidangoReduxAction {
        return {
            type: ShoppingCartActions.UPDATE_CART_TOTAL_PRICE,
            payload: payload
        };
    }

    postTicketRequestStart(): ShoppingCartAction {
        return {
            type: ShoppingCartActions.POST_TICKET_TO_CART_START
        };
    }

    postTicketRequestSuccess(): ShoppingCartAction {
        return {
            type: ShoppingCartActions.POST_TICKET_TO_CART_SUCCESS
        };
    }

    addTicketToCart(payload: Ticket): ShoppingCartAction {
        return {
            type: ShoppingCartActions.ADD_TICKET_TO_CART,
            payload: payload
        };
    }

    addVoucherTicketToCart(payload: Ticket): ShoppingCartAction {
        return {
            type: ShoppingCartActions.ADD_VOUCHER_TICKET_TO_CART,
            payload: payload
        };
    }

    postTicketRequestError(): ShoppingCartAction {
        return {
            type: ShoppingCartActions.POST_TICKET_TO_CART_ERROR
        };
    }

    postTicketRequestDone(): ShoppingCartAction {
        return {
            type: ShoppingCartActions.POST_TICKET_TO_CART_DONE
        };
    }

    fetchCartStart(): ShoppingCartAction {
        return {
            type: ShoppingCartActions.FETCH_CART_START
        };
    }

    fetchCartSuccess(): ShoppingCartAction {
        return {
            type: ShoppingCartActions.FETCH_CART_SUCCESS
        };
    }

    fetchCartError(): ShoppingCartAction {
        return {
            type: ShoppingCartActions.FETCH_CART_ERROR
        };
    }

    fetchCartDone(): ShoppingCartAction {
        return {
            type: ShoppingCartActions.FETCH_CART_DONE
        };
    }

    deleteCart(): ShoppingCartAction {
        return {
            type: ShoppingCartActions.DELETE_SHOPPING_CART
        };
    }


    removeTicketFromCart(ticket: Ticket, cart: ShoppingCart): RidangoReduxAction {
        return {
            type: ShoppingCartActions.REMOVE_TICKET_FROM_CART,
            payload: { ticket: ticket, cart: cart }
        };
    }

    removeGroupedTicketFromCart(ticket: Ticket, cart: ShoppingCart, uid: string): RidangoReduxAction {
        return {
            type: ShoppingCartActions.REMOVE_GROUPED_TICKET_FROM_CART,
            payload: { ticket: ticket, cart: cart, uid: uid }
        };
    }

    addLocalTicketToCart(localTicket: Ticket, serverTicket: Ticket, cart: ShoppingCart): RidangoReduxAction {
        return {
            type: ShoppingCartActions.ADD_LOCAL_TICKET_TO_CART,
            payload: { localTicket: localTicket, serverTicket: serverTicket, cart: cart }
        };
    }

    addLocalTicketUidToCart(localTicket: Ticket): RidangoReduxAction {
        return {
            type: ShoppingCartActions.ADD_LOCAL_TICKET_UID_TO_CART,
            payload: { ticket: localTicket }
        };
    }


    setTimer(timer: number): RidangoReduxAction {
        return {
            type: ShoppingCartActions.SET_CART_TIMER,
            payload: timer
        };
    }
    decrementCartTimer(): RidangoReduxAction {
        return {
            type: ShoppingCartActions.DECREMENT_CART_TIMER
        };
    }


    setStatus(status: string): RidangoReduxAction {
        return {
            type: ShoppingCartActions.SET_CART_STATUS,
            payload: status
        };
    }


    updateLocalTicketPrice(uid: string, price: number): RidangoReduxAction {
        return {
            type: ShoppingCartActions.UPDATE_LOCAL_TICKET_PRICE,
            payload: { uid: uid, price: price }
        };
    }

    clearCart(): RidangoReduxAction {
        return {
            type: ShoppingCartActions.CLEAR_CART
        };
    }

    setCartTermsAgreed(termsAgreed: boolean): RidangoReduxAction {
        return {
            type: ShoppingCartActions.SET_CART_TERMS_AGREED,
            payload: { termsAgreed: termsAgreed }
        };
    }


    hydrateCartState(cart: any): RidangoReduxAction {
        return {
            type: ShoppingCartActions.HYDRATE_CART_STATE,
            payload: cart
        };
    }

}
